import React, { Component } from 'react';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

export default class CreateTodo extends Component {
    state = {
        text: '',
        desc: ''
    };

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleSubmit = e => {
        e.preventDefault();
        this.props.createTodo(this.state);
        this.setState({
            text: '',
            desc: ''
        });
    };

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <FormGroup>
                    <Label>Enter task</Label>
                    <Input
                        type="text"
                        placeholder="Enter todo"
                        onChange={this.handleChange}
                        name="text"
                        value={this.state.text}
                    />
                </FormGroup>
                <FormGroup>
                    <Label>Describe Task</Label>
                    <Input
                        type="textarea"
                        placeholder="Enter short description"
                        onChange={this.handleChange}
                        name="desc"
                        value={this.state.desc}
                    />
                </FormGroup>
                <Button color="success">
                    Add Todo
                </Button>
            </Form>
        );
    }
}

CreateTodo.propTypes = {
    createTodo: PropTypes.func.isRequired
};